import React from "react";

import { MainFileType } from "../../../redux/Main/File/types";

// A held post's attachments, so approvers see everything that will go out, not only the text.
// url is the thumbnail and downLoadUrl the full file (as in the post list).
export const ApprovalPostMedia = ({ media }: { media?: MainFileType[] }) => {
    if (!media || media.length === 0) {
        return null;
    }

    return (
        <div className="d-flex flex-wrap gap-2 mt-2">
            {media.map((file, key) => {
                const type = file.contentType || '';
                const full = file.downLoadUrl || file.url;

                if (type.startsWith('image/') && file.url) {
                    return (
                        <a key={file.uuid || key} href={full} target="_blank" rel="noreferrer" title={file.fileName}>
                            <img src={file.url} alt={file.fileName || ''} className="rounded border" style={{ width: 96, height: 96, objectFit: 'cover' }} />
                        </a>
                    );
                }
                if (type.startsWith('video/') && full) {
                    return (
                        <video key={file.uuid || key} src={full} controls preload="metadata" className="rounded border" style={{ maxWidth: 240, maxHeight: 160 }} />
                    );
                }

                return (
                    <a key={file.uuid || key} href={full} target="_blank" rel="noreferrer" className="btn btn-sm btn-light d-inline-flex align-items-center">
                        <i className="ri-file-line me-1" />{file.fileName}
                    </a>
                );
            })}
        </div>
    );
};
